export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  company?: string;
  service: string;
  message: string;
  website?: string;
}

export type ContactFieldErrors = Partial<Record<keyof ContactFormData, string>>;

export type SendContactResult =
  | { success: true }
  | { success: false; error: string; fields?: ContactFieldErrors };

const GENERIC_ERROR = 'We could not send your message. Please try again, or email us directly.';

export const sendContactEmail = async (formData: ContactFormData): Promise<SendContactResult> => {
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok || !result.success) {
      return {
        success: false,
        error: typeof result.error === 'string' ? result.error : GENERIC_ERROR,
        fields: result.fields,
      };
    }

    return { success: true };
  } catch (error) {
    return { success: false, error: GENERIC_ERROR };
  }
};
